import { Box, TextField, Button, Checkbox, FormControlLabel } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './fulfillPageStyles.scss';

const baseUrl = 'https://agentricity.com'; // 'http://localhost:5000' //


const FulfillPage = () => {
    const [emailData, setEmailData] = useState('');
    const [emailHasError, setEmailHasError] = useState(false);
    const [requestData, setRequestData] = useState('');
    const [checked, setChecked] = useState(true); // Checkbox is checked by default

    useEffect(() => {
        document.title = 'Aggie - Requests';
        const cookies = document.cookie.split('; ').reduce((prev, current) => {
            const [name, value] = current.split('=');
            prev[name] = value;
            return prev;
        }, {} as any);

        const token = cookies['authToken'];
        const email = cookies['email'];

        if (token && email) {
            console.log("token found" + token)
            localStorage.setItem('authToken', token);
        } else {
            console.log("No token found, redirecting to signin")
            window.location.href = 'signin';
        }

        if (email) {
            setEmailData(email);
        }
    }, []);

    const validateEmail = (email: string) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmailData(e.target.value);
        if (emailHasError && validateEmail(e.target.value)) {
            setEmailHasError(false);
        }
    };

    const handleSubmit = async () => {
        if (!checked) {
            alert('Please agree to the terms before submitting.');
            return;
        }
        if (!validateEmail(emailData)) {
            setEmailHasError(true);
            return;
        } else {
            setEmailHasError(false);
        }
        try {
            const jwtResponse = await fetch(`${baseUrl}/api/auth`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "username": "dev@example.com",
                    "password": "devPassword"
                })
            })
            console.log(`Authentication response status: ${jwtResponse.status}`); // Log the response status
            if (!jwtResponse.ok) {
                const errorData = await jwtResponse.text(); // Get response text when not ok
                console.error(`Authentication error response: ${errorData}`); // Log the error response
                throw new Error('Authentication response was not ok')
            }
            const jwtData = await jwtResponse.json()
            console.log(`Authentication response data: ${JSON.stringify(jwtData)}`); // Log the response data
            const token = jwtData.token

            const res = await fetch(`${baseUrl}/api/user_request`, { // await fetch(`${baseUrl}/api/users_create`, { // 
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    email: emailData,
                    request_text: requestData,
                    charity_name: 'Wishes for sick kids',
                    status: 'unspecified',
                    status_detail: '',
                    extras: '{}'
                })
            })

            console.log(`API response status: ${res.status}`); // Log the response status
            if (!res.ok) {
                const errorData = await res.text(); // Get response text when not ok
                console.error(`API error response: ${errorData}`); // Log the error response
                throw new Error('API response was not ok')
            }
            const data = await res.json()
            console.log(`API response data: ${JSON.stringify(data)}`); // Log the response data

            if (data.error) {
                throw new Error(data.error)
            }

            alert('Request submitted')
        } catch (error: any) {
            console.error('Error:', error)
        }
    };

    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
    };

    return (
        <div id="fulfillPageContainer">
            <div className='pageTitle'>I Can Help</div>
            <h2 className="text-center mb-10 text-gray-500">What would you like done? <br /></h2>
            <Box
                component="form"
                noValidate
                autoComplete="off"
                className="formContainer"
            >
                <TextField
                    label="Request"
                    placeholder="Please help me with..."
                    variant="outlined"
                    multiline
                    onChange={(val) => setRequestData(val.target.value)}
                    className="textField" />
                <TextField
                    label="Email"
                    placeholder="Aggie@AwesomeAI.com"
                    variant="outlined"
                    onChange={handleEmailChange}
                    className="textField"
                    error={emailHasError}
                    helperText={emailHasError ? 'Please enter a valid email address' : ''}
                    value={emailData}
                    InputProps={{
                        readOnly: Boolean(emailData),
                    }}
                />
                <FormControlLabel
                    className="customFormControlLabel" // Add this class
                    control={
                        <Checkbox
                            checked={checked}
                            onChange={handleCheckboxChange}
                            name="checked"
                            color="primary"
                        />
                    }
                    label="I consent to the use of my email address and first name for the purpose of receiving updates and personalized communication regarding my request"
                />
                <Button onClick={handleSubmit} variant="contained" disabled={!checked}>Submit</Button>
            </Box>
        </div>
    );
}

export default FulfillPage;